// extracted by mini-css-extract-plugin
export default {"summaryContainer":"Actions_summaryContainer__i5BG-","summary":"Actions_summary__XsYD2"};